export enum DatasheetFieldComponentTextAlign {
  left = 0,
  center = 1,
  right = 2,
}